function fxSx(mixin, theme) {
    if (typeof(mixin) === 'function') return mixin(theme);
    return mixin;
}

export { fxSx };
